export default __webpack_public_path__ + "static/media/MetalProduction_bg.cf6caa5f.jpg";